import { positionEquals } from "./equalCheckers";
import { stringReverse } from "./stringReverse";

/**
 *
 * @param {Answer[]} words Correct words
 * @param {WordSelection} selector
 * @returns {number} Word Id of selector, -1 otherwise
 */
export function selectorCheck(words, selector) {
  return words.findIndex((it) => {
    const startPos = it.position;
    const direc = it.direction;

    /** @type {Position} */
    const endPos = {
      x: startPos.x + direc.x * (it.content.length - 1),
      y: startPos.y + direc.y * (it.content.length - 1),
    };

    const contentMatch =
      it.content.toUpperCase() === selector.word ||
      it.content.toUpperCase() === stringReverse(selector.word);

    const startPosMatch =
      positionEquals(startPos, selector.origin.position) ||
      positionEquals(startPos, selector.destination.position);

    const endPosMatch =
      positionEquals(endPos, selector.destination.position) ||
      positionEquals(endPos, selector.origin.position);

    return contentMatch && startPosMatch && endPosMatch;
  });
}
